import React = require('react');
import DateTool from '../../datetool/source/DateTool';

export interface ICommentProps {
    eventId:number
    targetUserId:number
    toId:number
    open:boolean
}


interface IAddItem{
    (comment:string, toId:number, targetUserId:number):void
}

export interface ICommentRowProps extends ICommentProps {
    item:IComments
    addItem:IAddItem
}

export interface IComments{
    id: number
    comment: string
    toId: number
    targetUserId: number
    fromUserId: number
    date:string
    userImage: string,
    userName: string
    userInfo: string
}

interface ICommentRowState{
    comment:string
    item: IComments
    open: boolean
}

export class CommentRow extends React.Component<ICommentRowProps, ICommentRowState>{

    constructor(props:ICommentRowProps){
        super(props);
        this.state = {
            comment: '',
            item: this.props.item,
            open: this.props.open
        }
        // FIXME: ha al comment kell akkor itt le kell kérdezni....

    }

    private submitHandler(evt): void {
        evt.preventDefault();
        if (this.state.comment.trim() === '') {
            return;
        }
        this.props.addItem(
            this.state.comment,
            this.props.toId,
            this.props.targetUserId
        );
        this.setState({
             comment: ''
        });
    }

    private commentChangeHandler(evt): void {
        evt.preventDefault();
        this.setState({
             comment: evt.target.value
        });
    }

    private openClickHandler(evt): void {
        evt.preventDefault();
        this.setState({
             open: !this.state.open
        });
    }

    render() {
        var sendBtnStyle:any={ opacity: 0.5 };
        if (this.state.comment.trim() !== '') {
            sendBtnStyle = {};
        }
        return (
            <div className="comment_row">
                { this.state.item !== null?<div className="read_box">
                    <div className="row col2">
                        <div className="box">
                            <img src={this.state.item.userImage} alt=""/>
                        </div>
                        <div className="box">
                            <div className="user_name">
                                { this.state.item.userName }
                            </div>
                            <div className="user_info">
                                { this.state.item.userInfo }
                            </div>
                            <div className="date">
                                { DateTool.getDateHu(this.state.item.date)+'.' }
                            </div>
                        </div>
                    </div>
                    <div className="comment">
                        { this.state.item.comment }
                    </div>
                    { /*this.state.open === false ?<div>
                        <a href="#open" className="button" onClick={ e => this.openClickHandler(e) }
                        >Válasz</a>
                    </div>:'' */}

                </div>:'' }
                { this.state.open === true?<div>
                    <div className="write_box">
                        <form onSubmit={ e => this.submitHandler(e) }>
                            <legend>Üzenet írása</legend>
                            <textarea value={ this.state.comment } onChange={ e => this.commentChangeHandler(e) }
                             placeholder="ide írhatod az üzeneted…"></textarea>
                            <div className="button_bar" style={sendBtnStyle}>
                                <button className="btn" type="submit">Küldés</button>
                            </div>
                        </form>
                    </div>
                </div>:'' }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./avernus/comment/source/CommentRow.tsx